<template>
  <div>
    <div class="quickview is-right" :class="{'is-active': IDE.playground.active}">
      <div @click="IDE.playground.active = !IDE.playground.active"
           :class="{'is-show': IDE.playground.active}"
           class="button is-link toggle-nav"
           title="代码编辑器">
        <v-color-icon name="arrow-left-fill" :rotate="!IDE.playground.active ? 0 : 180"></v-color-icon>
      </div>

      <header class="quickview-header">
        <button class="button is-small is-link"
                @click="run"
                :disabled="shell.status === 'running'">
          <v-color-icon v-if="shell.status === 'running'" name="loader" fill="white" :spin="true"></v-color-icon>
          <v-color-icon v-else name="play"></v-color-icon>
          <span v-show="shell.status !== 'running'">运行</span>
          <span v-show="shell.status === 'running'">运行中</span>
        </button>
      </header>
      <div class="quickview-body">

        <div class="editor">
          <ace-editor v-model="IDE.playground.code" :height="'calc(100vh - 300px)'"
                      :run="run"></ace-editor>
        </div>
        <div class="output">
          <p class="heading">程序输出</p>
          <code-output
              :output="shell.output"></code-output>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'bulma-quickview/dist/css/bulma-quickview.min.css'
import AceEditor from '@/common/ace_editor/AceEditor'
import OnlineJudgePython from '@/plugin/web_ide/OjPython'
import CodeOutput from '@/components/classroom/messages/partials/CodeOutput'

const IDE = window['IDE']

export default {
  data () {
    return {
      IDE,
      python: null,
      shell: {
        status: 'init',
        output: '',
        error: '',
        startAt: 0,
        endAt: 0
      }
    }
  },
  methods: {
    async run () {
      if (!IDE.playground.code || this.shell.status === 'running') {
        return
      }
      this.python = new OnlineJudgePython(this, this.shell)
      this.python.run(IDE.playground.code, this.shell, IDE.playground.attachments)
    }
  },
  components: { CodeOutput, AceEditor }
}
</script>

<style lang="stylus" scoped>
.quickview {
  z-index: $zIndexFloat;
}

.quickview-header {
  height 61px
  padding-left 2rem
}

.toggle-nav {
  position: absolute;
  top: 10px
  left -50px
  z-index: $zIndexFloat + 1;
  cursor: pointer;
  width 40px

  height 40px
  display flex
  justify-content center
  align-items center
  border-radius 30px
  transition all .3s
  padding 0

  &.is-show {
    left -25px
  }

  .icon {
    font-size 22px
    transition all .3s linear .6s
  }
}

.coding :hover {
  opacity: 1;
}

.output {
  padding 5px
}

.heading {
  font-size 12px
  letter-spacing 1px
  color #888888
}

.editor {
  border-bottom 1px solid #dddddd
}
</style>
